// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2_Wpb","subheader":"ReorderModal_subheader__3GJ2R","listWrap":"ReorderModal_listWrap__10CEd"};